import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get } from 'lodash';
import type { DeleteLocationMutation } from '#/graphql/types';
import { deleteLocation } from '#/graphql/mutations';
import { GET_ASSET_PROPS_COUNTS } from '../../hooks/useAssetPropsCountsQuery';

const q = gql(deleteLocation);

const useLocationDelete = () => {
  const [mutation, result] = useMutation<DeleteLocationMutation>(q);
  const deleteLocation = useCallback(
    async (itemId: string) => {
      const response = await mutation({
        variables: {
          id: itemId,
        },
        refetchQueries: [{ query: GET_ASSET_PROPS_COUNTS }],
        awaitRefetchQueries: true,
      });

      return get(response, 'data.deleteLocation.data', undefined);
    },
    [mutation],
  );

  return { deleteLocation, result };
};

export default useLocationDelete;
